import React, { useState } from 'react';
import CustomInput from '../custominput/CustomInput';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import EventLabel from '../EventLabel/EventLabel';

export const PasswordDialog = ({ onSuccess, pwd, contentId }) => {
  const [inputValue, setInputValue] = useState('');
  const [showValidationMsg, setShowValidationMsg] = useState(false);

  const handleInput = e => {
    setInputValue(e.target.value);
  };

  const onClick = () => {
    if (inputValue === pwd) {
      setShowValidationMsg(false);
      localStorage.setItem(`pwd_${contentId}`, btoa(inputValue));
      onSuccess();
    } else {
      setShowValidationMsg(true);
    }
  };

  const onKeyDown = (e) => e.keyCode === 13 && onClick();

  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <EventLabel name="PasswordDialogTitle" groupName="CMS.PasswordDialog" />
      </DialogTitle>
      <DialogContent>
        <CustomInput
          onChange={handleInput}
          label={<EventLabel name="PasswordInputLabel" groupName="CMS.PasswordDialog" />}
          value={inputValue}
          onKeyDown={onKeyDown}
        />
        {showValidationMsg && (
          <p className="text-red">
            <EventLabel name="PasswordValidationMsg" groupName="CMS.PasswordDialog" />
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClick} color="primary">
          <EventLabel name="PasswordDialogOk" groupName="CMS.PasswordDialog" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
